import { useEffect } from 'react'
import { useAuthStore } from 'src/store/auth'
import { ProfileForm } from 'src/components/profileForm/ProfileForm'

export const Settings = () => {
  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  useEffect(() => {
    setActiveKeyMainMenu('')
  }, [setActiveKeyMainMenu])

  return <ProfileForm />
}
